// embed-twitter/client.js
// JS to initiate after DOMReady.
import socialEmbeds from '../element/shared/utils/social-embeds.js';

export default function () {
  // Add Twitter script
  const id = 'twitter-script';
  if (!document.getElementById(id)) {
    const script = document.createElement('script');
    script.id = id;
    script.src = '//platform.twitter.com/widgets.js';
    document.body.appendChild(script);
  }

  // Load all Twitter embeds on the page
  const embeds = Array.prototype.slice.call(document.getElementsByClassName('js-embed-twitter'));
  embeds.forEach((element) => {
    if (!element.childNodes.length) {
      socialEmbeds.get(element);
    }
  });
}
